import React, { Fragment } from 'react';

export const ALL_ITEMS_LINK = '/sg/en/eyeglasses/brands/toystory.html';
export const STORES_LINK = '/stores/sg';

export const CONCEPT = {
  desc: (
    <Fragment>
      Do you remember your first toy?
      <br />
      What about your favourite one?
      <br />
      Step into the TOY STORY | OWNDAYS eyewear collection where imagination and childhood joy come
      to life once again. Inspired by the beloved Disney Pixar Toy Story characters, the collection
      features 12 models, each capturing the unique charm of Woody, Buzz Lightyear, Jessie, Rex, Bo
      Peep and more! Each frame comes with a themed spectacle case and lens cleaning cloth,
      available in two designs featuring best friends, Woody and Buzz Lightyear.
      <br />
      Let’s Bring Back the Moment with the TOY STORY | OWNDAYS collection today.
    </Fragment>
  ),
};

export const NAV_ITEMS = [
  {
    key: 'woody',
    delay: 0,
    scrollTargets: ['#woody-1', '#woody-2'],
    images: ['nav-img-1-1.webp', 'nav-img-1-2.webp'],
    showTag: true,
  },
  {
    key: 'buzz',
    delay: 100,
    scrollTargets: ['#buzz-1', '#buzz-2'],
    images: ['nav-img-2-1.webp', 'nav-img-2-2.webp'],
    showTag: true,
  },
  {
    key: 'jessie',
    delay: 200,
    scrollTargets: ['#jessie'],
    images: ['nav-img-3.webp'],
  },
  {
    key: 'rex',
    delay: 300,
    scrollTargets: ['#rex'],
    images: ['nav-img-4.webp'],
  },
  {
    key: 'lotso',
    delay: 400,
    scrollTargets: ['#lotso'],
    images: ['nav-img-5.webp'],
  },
  {
    key: 'aliens',
    delay: 500,
    scrollTargets: ['#aliens'],
    images: ['nav-img-6.webp'],
  },
  {
    key: 'bo-peep',
    delay: 600,
    scrollTargets: ['#bo-peep'],
    images: ['nav-img-7.webp'],
  },
  {
    key: 'mr-and-mrs-potato-head',
    delay: 700,
    scrollTargets: ['#mr-and-mrs-potato-head'],
    images: ['nav-img-8.webp'],
  },
  {
    key: 'slinky-dog',
    delay: 800,
    scrollTargets: ['#slinky-dog'],
    images: ['nav-img-9.webp'],
  },
  {
    key: 'sid-phillips',
    delay: 900,
    scrollTargets: ['#sid-phillips'],
    images: ['nav-img-10.webp'],
  },
];

export const EXCLUSIVE = {
  title: (
    <>
      Exclusive <br />
      Merchandise Set
    </>
  ),
  desc: `This exclusive merchandise set comes with every purchase of a TOY STORY | OWNDAYS spectacle frame. It includes a specially designed spectacle case and a lens cleaning cloth, both available in two designs featuring best friends Woody and Buzz Lightyear.`,
  woody: {
    title: 'Woody Set',
    desc: `A Woody-themed spectacle case with a bold red exterior and a vibrant yellow interior. Open it to reveal a print of the TOY STORY gang inside. Comes with a matching lens cleaning cloth.`,
    list: ['/woody-set-1.webp', '/woody-set-2.webp', '/woody-set-3.webp'],
  },
  buzz: {
    title: 'Buzz Lightyear Set',
    desc: `A Buzz Lightyear-themed spectacle case with a bold blue exterior and a vibrant green interior. Open it to reveal a print of the TOY STORY gang inside. Comes with a matching lens cleaning cloth.`,
    list: [
      '/buzz-lightyear-set-1.webp',
      '/buzz-lightyear-set-2.webp',
      '/buzz-lightyear-set-3.webp',
    ],
  },
};

export const SHARES = {
  list: [
    'Not valid in conjunction with other discounts, promotions and/or privileges',
    'No cancellation, refund, exchange or change of order details once an order is placed',
    'Resale or transfer is strictly prohibited',
    'Delivery within Singapore only',
    'Certain prescription cannot be added to the lenses due to constraints in the lens power',
    'Upgrade to optional lenses is available at additional charges',
    'There is no product warranty except for warranty on lens visual performance if lenses have been replaced',
  ],
  socials: [
    {
      link: 'https://www.facebook.com/sharer/sharer.php?u=https://www.owndays.com/sg/en/news/toystory',
      className: 'fa-facebook',
    },
    {
      link: 'whatsapp://send?text=https://www.owndays.com/sg/en/news/toystory',
      className: 'fa-whatsapp',
    },
  ],
};

export const LINEUP = {
  woody: {
    products: [
      {
        title: 'Woody',
        key: 'woody-1',
        number: 'DN1001N-5S',
        price: 'S$218',
        limit: 8,
        desc: `Inspired by Sheriff Woody, the beloved cowboy doll, this metal polygon frame with SNAP LENS is a versatile choice for any occasion. The temples showcase badge-shaped patterns while the blue temple tips are a nod to Woody’s iconic jeans. Adding a playful touch, his signature cowboy hat adorns the right temple tip while the left features a boot print with the name “Andy”—a heartfelt detail from the classic tale.`,
        points: [
          `Temples reflect Woody's signature shirt and bandana colour scheme`,
          `A cowboy hat on the right temple tip`,
          `A boot print with the name “Andy” on the left temple tip`,
        ],
      },
      {
        title: 'Woody',
        key: 'woody-2',
        number: 'DN2002B-5S',
        price: 'S$198',
        limit: 5,
        desc: `This Wellington frame embodies classic cowboy charm. The rim features a sheriff badge emblem on each side while the temples resemble cowboy ropes, complete with motifs inspired by Woody’s belt buckle. This one-of-a-kind design adds a bold, standout touch to your style.`,
        points: [
          `Metal star-shaped sheriff emblems on the front bring a touch of Western charm`,
          `Cowboy rope-inspired temples, accented with Woody's signature belt buckle motifs`,
          `Woody’s signature bandanna pattern adorns the upper rim`,
        ],
      },
    ],
  },
  buzz: {
    products: [
      {
        title: 'Buzz Lightyear',
        key: 'buzz-1',
        number: 'DN1002N-5S',
        price: 'S$218',
        limit: 8,
        desc: `This metal polygon frame is a tribute to space ranger Buzz Lightyear. The temples are designed in his signature colour scheme and embellished with star patterns. The right temple proudly displays the Star Command emblem while the left features a footprint with the name “Andy”. Equipped with SNAP LENS for instant sun protection, this frame ensures you’re always ready for your next cosmic adventure to infinity and beyond.`,
        points: [
          `Temples showcase Buzz Lightyear’s signature colour scheme`,
          `The Star Command emblem on the right temple tip`,
          `A footprint with the name “Andy” on the left temple tip`,
        ],
      },
      {
        title: 'Buzz Lightyear',
        key: 'buzz-2',
        number: 'DN1003B-5S',
        price: 'S$178',
        limit: 5,
        desc: `Embark on a space adventure with this stylish round frame in a vibrant purple hue, inspired by Buzz Lightyear’s iconic Space Ranger suit. The temples are adorned with symbols of courage—the Star Command and Space Ranger emblems. Engraved with “Buzz” on the left temple and “Lightyear” on the right, this frame will be your special companion for every journey!`,
        points: [
          `The left temple is engraved with the word “Buzz” and features a Star Command motif`,
          `The right temple is engraved with the word “Lightyear” and features a Space Ranger motif`,
        ],
      },
    ],
  },
  jessie: {
    products: [
      {
        title: 'Jessie',
        key: 'jessie',
        number: 'DN2001B-5S',
        price: 'S$198',
        limit: 5,
        desc: `This vintage-style Wellington frame takes inspiration from the cowgirl rag doll, Jessie. The temples resemble cowgirl ropes, accented with playful belt buckle motifs. The temple tips echo her cow-patterned jeans with colours reminiscent of her favourite boots, bringing her fun and charming cowgirl vibe to life.`,
        points: [
          `Metal bow-shaped emblems on the front add a touch of cuteness`,
          `Cowgirl rope-inspired temples, accented with Jessie's signature belt buckle motifs`,
          `A pattern inspired by Jessie’s shirt adorns the upper rim`,
        ],
      },
    ],
  },
  rex: {
    products: [
      {
        title: 'Rex',
        key: 'rex',
        number: 'DN1004B-5S',
        price: 'S$178',
        limit: 5,
        desc: `This round frame in a delightful green hue embodies the charm of Rex, the timid little dinosaur. Thoughtfully designed with green metal temples, it features “Rex” engraved on the left and his classic “roar” on the right. Adorable temple tips shaped like Rex’s feet add a playful and distinctive touch to your look!`,
        points: [
          `Frame front designed in the shape of a dinosaur claw, with tiny footprint motifs on the temples`,
          `Green metal temples feature “Rex” engraved on the left and “roar” on the right`,
          `Temple tips shaped like Rex’s feet`,
        ],
      },
    ],
  },
  lotso: {
    products: [
      {
        title: 'Lotso',
        key: 'lotso',
        number: 'DN2003N-5S',
        price: 'S$178',
        limit: 5,
        desc: `Sweet and gentle, this pink Boston frame reflects the distinctive appeal of Lotso, the pink teddy bear. A strawberry motif is placed on each side of the frame front while the metal wire cores showcase playful engravings. It’s a lovely choice to brighten up your look.`,
        points: [
          `Strawberry-shaped accents on the front add a touch of sweetness`,
          `Engravings of Lotso and flowers adorn the temple wire cores`,
          `A Lotso emblem on the right temple tip`,
        ],
      },
    ],
  },
  aliens: {
    products: [
      {
        title: 'Aliens',
        key: 'aliens',
        number: 'DN2004N-5S',
        price: 'S$178',
        limit: 5,
        desc: `A green Boston frame inspired by the tiny three-eyed alien character. Luxurious metal rivets in a three-eyed design accent the front while clear temples reveal futuristic space rocket patterns along the inner wire cores. Finished with an Alien face on the right temple tip, this unique design lets you embark on every adventure with confidence and style.`,
        points: [
          `Metal rivets in a three-eyed design on the front`,
          `Clear temples reveal space rocket patterns along the inner wire cores`,
          `Aliens’ face embedded in the right temple tip`,
        ],
      },
    ],
  },
  boPeep: {
    products: [
      {
        title: 'Bo Peep',
        key: 'bo-peep',
        number: 'DN1005B-5S',
        price: 'S$178',
        limit: 5,
        desc: `A Crown Panto frame inspired by the beautiful shepherdess character. The metal temples are designed to resemble Bo Peep's shepherd's crook while the inner sides feature pink polka dots reminiscent of her signature dress. Adorned with bow-shaped motifs on both temples, this design offers a sweet and elegant style for the modern woman.`,
        points: [
          `Pink upper rim inspired by Bo Peep’s hair bow`,
          `Metal temples resemble shepherd’s crook, with bow-shaped motifs on both sides`,
          `Pink polka dots on the inner side of the temples`,
        ],
      },
    ],
  },
  mrAndMrsPotatoHead: {
    products: [
      {
        title: 'Mr. & Mrs. Potato Head',
        key: 'mr-and-mrs-potato-head',
        number: 'DN1006B-5S',
        price: 'S$178',
        limit: 5,
        desc: `This Boston frame draws inspiration from the unique characteristics of the lovable couple, Mr. & Mrs. Potato Head. The temples are crafted to resemble their arms in a two-tone colour scheme, perfectly capturing their playful essence. Colourful motifs depicting a flower and a hat embellish the temples, infusing a vibrant and lively energy into your everyday style.`,
        points: [
          `Orange upper rim inspired by Mr. & Mrs. Potato Head`,
          `Left temple in red, with a flower motif to represent Mrs. Potato Head`,
        ],
      },
    ],
  },
  slinkyDog: {
    products: [
      {
        title: 'Slinky Dog',
        key: 'slinky-dog',
        number: 'DN2006B-5S',
        price: 'S$198',
        limit: 5,
        desc: `This Boston acetate frame is designed with the playful toy Dachshund, Slinky Dog, in mind. Design highlights include a double bridge, Slinky-inspired details on the temples and temple tips shaped like paws. With its whimsical elements, it’s sure to delight any dog lover!`,
        points: [
          `Frame colour inspired by Slinky Dog`,
          `Metal temples feature Slinky-inspired details`,
          `End tips shaped like paws`,
        ],
      },
    ],
  },
  sidPhillips: {
    products: [
      {
        title: 'Sid Phillips',
        key: 'sid-phillips',
        number: 'DN2005B-5S',
        price: 'S$198',
        limit: 5,
        desc: `This acetate Boston frame channels the rebellious spirit of Sid Phillips with its sleek black theme and quirky double bridge design. The temples, crafted to resemble braces, are complemented by skull-shaped metal accents at the temple tips, adding depth and attitude. This unorthodox approach to frame design makes it the ultimate choice for those who dare to stand out.`,
        points: [
          `Matte black frame inspired by Sid Phillips`,
          `Metal temples feature braces-inspired details`,
          `End tips shaped like skulls`,
        ],
      },
    ],
  },
};
